import { ReactElement } from "react";

interface IProps {
  width?: number;
  height?: number;
  fill?: string;
}

const KitchenPanicIcon = ({
  width = 17,
  height = 14,
  fill = "white",
}: IProps): ReactElement => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 1431">
      <path
        id="Vector"
        d="M4.36581 10.0947H5.52969C4.78625 9.56322 4.26154 8.77946 4.05346 7.8896C4.04234 7.81658 4.06039 7.74211 4.10369 7.68228C4.147 7.62244 4.2121 7.58203 4.28494 7.56977C4.35778 7.5575 4.43252 7.57437 4.49303 7.61673C4.55354 7.65909 4.59497 7.72354 4.60838 7.79618C4.61936 7.85865 4.89569 9.31969 6.64516 10.0947H8.55194V8.12486C8.55194 8.05022 8.58159 7.97865 8.63436 7.92587C8.68713 7.8731 8.75871 7.84345 8.83334 7.84345C8.90797 7.84345 8.97955 7.8731 9.03232 7.92587C9.0851 7.97865 9.11474 8.05022 9.11474 8.12486V10.0947H11.0215C12.7839 9.3135 13.0558 7.8125 13.0583 7.7973C13.0725 7.72553 13.114 7.66209 13.1742 7.62045C13.2344 7.5788 13.3084 7.56223 13.3805 7.57423C13.4527 7.58624 13.5174 7.62588 13.5608 7.68475C13.6043 7.74363 13.6231 7.8171 13.6132 7.8896C13.405 8.77941 12.8803 9.56313 12.137 10.0947H13.3017C13.6602 10.0035 16.7126 9.1289 16.7126 5.87364C16.7114 5.0644 16.3936 4.28774 15.8271 3.70987C15.2606 3.132 14.4904 2.79881 13.6813 2.7816C13.7202 2.86602 13.7587 2.94904 13.7916 3.03205C13.8063 3.0666 13.8139 3.10374 13.814 3.14128C13.8141 3.17881 13.8067 3.21599 13.7922 3.25062C13.7778 3.28525 13.7565 3.31663 13.7297 3.34292C13.7029 3.36921 13.6711 3.38987 13.6362 3.40369C13.6013 3.41751 13.564 3.4242 13.5265 3.42338C13.4889 3.42256 13.452 3.41424 13.4177 3.39891C13.3834 3.38358 13.3526 3.36154 13.327 3.33411C13.3013 3.30668 13.2815 3.27439 13.2685 3.23916C13.1885 3.03944 13.0945 2.84563 12.9871 2.65919C12.5692 1.92627 11.9648 1.31697 11.2353 0.893149C10.5057 0.469334 9.67705 0.246094 8.83334 0.246094C7.98964 0.246094 7.16096 0.469334 6.43142 0.893149C5.70189 1.31697 5.09749 1.92627 4.67958 2.65919C4.57211 2.84549 4.47807 3.03921 4.39817 3.23888C4.3775 3.29145 4.34148 3.33658 4.29481 3.3684C4.24813 3.40022 4.19296 3.41725 4.13647 3.41729C4.09057 3.4173 4.04536 3.40608 4.00479 3.3846C3.96421 3.36313 3.92951 3.33206 3.9037 3.2941C3.8779 3.25613 3.86177 3.21243 3.85672 3.16681C3.85168 3.12118 3.85787 3.07502 3.87477 3.03233C3.90741 2.9496 3.94596 2.86546 3.98508 2.7816C3.17606 2.79888 2.40594 3.1321 1.83949 3.70997C1.27303 4.28783 0.955241 5.06445 0.954102 5.87364C0.954102 9.10301 4.03545 10.0071 4.36581 10.0947Z"
        fill={fill}
      />
      <path
        id="Vector_2"
        d="M4.61237 13.4712C4.61237 13.5459 4.64201 13.6174 4.69479 13.6702C4.74756 13.723 4.81913 13.7526 4.89377 13.7526H12.773C12.8476 13.7526 12.9192 13.723 12.972 13.6702C13.0248 13.6174 13.0544 13.5459 13.0544 13.4712V10.6572H4.61237V13.4712Z"
        fill={fill}
      />
    </g>
  </svg>
);

export default KitchenPanicIcon;
